// The friendly answer to a `402` on any Boot route: the organisation does not have Clavian Boot. Not an error to retry —
// something to tell the owner, and the way to ask for it.

import { useTranslation } from '@clavian/i18n/react';
import { EmptyState } from '@clavian/ui-web';
import type { ReactNode } from 'react';

import { Icon } from '../shell/nav-icons';

export function NotOnPlan(): ReactNode {
  const { t } = useTranslation('console');
  return <EmptyState icon={<Icon name="boot" />} title={t('boot.notOnPlan.title')} description={t('boot.notOnPlan.body')} />;
}
